import React, { useEffect, useState } from 'react'
import { Button, Col, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap'
import CustomDatePicker from '../CustomDatePicker';
import { formatInTimeZoneDate } from '../../helpers';
import FormValidator from '../FormValidation';
import * as Constants from '../../store/Constants'
import { getProducts } from '../../api/productapi';
import feedback from '../utils/feedback'
import InputFeedback from '../utils/InputFeedback';

const isBefore = (confirmation, state) => (state.endDate >= confirmation || !state.endDate)
const productSelected = productList => productList.length > 0
const isSelectedValuePrimary = (value, state) => {
    if (state.applyToPrimeMember && value === Constants.promoTypeNone)
        return true
    return false
}
const isSelectedValueEnrollment = (value, state) => {
    if (state.applyToEnrollFee && value === Constants.promoTypeNone)
        return true
    return false
}
const isSelectedValueAssociates = (value, state) => {
    if (state.applyToAssoc && value === Constants.promoTypeNone)
        return true
    return false
}

const isFloat = (num) => {
    return /^\d+(\.\d{1,2})?$/.test(String(num));
}



export const validator = (applyToCart = false, promoTypeCode = Constants.promoTypeNone, enrollFeePromoTypeCode = Constants.promoTypeNone, assocPromoTypeCode = Constants.promoTypeNone) => {
    return new FormValidator([
        { field: 'promoCodeCode', method: 'isEmpty', validWhen: false, message: 'Value is required.' },
        { field: 'name', method: 'isEmpty', validWhen: false, message: 'Value is required.' },
        { field: 'clubName', method: 'isEmpty', validWhen: !!applyToCart, message: 'Value is required.' },
        { field: 'branchName', method: 'isEmpty', validWhen: !!applyToCart, message: 'Value is required.' },
        { field: 'promoCodeProducts', method: productSelected, validWhen: !applyToCart, message: 'Value is required.' },
        { field: 'startDate', method: 'isEmpty', validWhen: false, message: 'Value is required.' },
        { field: 'endDate', method: 'isEmpty', validWhen: false, message: 'Value is required.' },
        { field: 'startDate', method: isBefore, validWhen: true, message: 'Start date must be before end date.' },
        { field: 'promoTypeCode', method: isSelectedValuePrimary, validWhen: false, message: 'Select value' },
        { field: 'enrollFeePromoTypeCode', method: isSelectedValueEnrollment, validWhen: false, message: 'Select value' },
        { field: 'assocPromoTypeCode', method: isSelectedValueAssociates, validWhen: false, message: 'Select value' },
        { field: 'percentage', method: 'isEmpty', validWhen: promoTypeCode !== Constants.promoTypePercentage, message: 'Value is required.' },
        { field: 'percentage', method: 'isInt', args: [{ min: 1, max: 100 }], validWhen: promoTypeCode == Constants.promoTypePercentage, message: 'Value must be an integer between 1 to 100.' },
        { field: 'fixedAmount', method: 'isEmpty', validWhen: promoTypeCode != Constants.promoTypeFixedAmount, message: 'Value is required.' },
        { field: 'fixedAmount', method: isFloat, validWhen: promoTypeCode === Constants.promoTypeFixedAmount, message: 'Value must be a valid number with up to 2 decimal places.' },
        { field: 'promoCodeNote', method: 'isEmpty', validWhen: promoTypeCode != Constants.promoTypeOther, message: 'Value is required.' },
        { field: 'enrollFeePercentage', method: 'isEmpty', validWhen: enrollFeePromoTypeCode != Constants.promoTypePercentage, message: 'Value is required.' },
        { field: 'enrollFeePercentage', method: 'isInt', args: [{ min: 1, max: 100 }], validWhen: enrollFeePromoTypeCode === Constants.promoTypePercentage, message: 'Value must be an integer between 1 to 100.' },
        { field: 'enrollFeeFixedAmount', method: 'isEmpty', validWhen: enrollFeePromoTypeCode !== Constants.promoTypeFixedAmount, message: 'Value is required.' },
        { field: 'enrollFeeFixedAmount', method: isFloat, validWhen: enrollFeePromoTypeCode === Constants.promoTypeFixedAmount, message: 'Value must be a valid number with up to 2 decimal places.' },
        { field: 'assocPercentage', method: 'isEmpty', validWhen: assocPromoTypeCode !== Constants.promoTypePercentage, message: 'Value is required.' },
        { field: 'assocPercentage', method: 'isInt', args: [{ min: 1, max: 100 }], validWhen: assocPromoTypeCode === Constants.promoTypePercentage, message: 'Value must be an integer between 1 to 100.' },
        { field: 'assocFixedAmount', method: 'isEmpty', validWhen: assocPromoTypeCode !== Constants.promoTypeFixedAmount, message: 'Value is required.' },
        { field: 'assocFixedAmount', method: isFloat, validWhen: assocPromoTypeCode === Constants.promoTypeFixedAmount, message: 'Value must be a valid number with up to 2 decimal places.' },
        { field: 'assocFreeCount', method: 'isEmpty', validWhen: assocPromoTypeCode !== Constants.promoTypeFreeAssociates, message: 'Value is required.' },
        { field: 'assocFreeCount', method: 'isInt', args: [{ min: 1, max: 5 }], validWhen: assocPromoTypeCode === Constants.promoTypeFreeAssociates, message: 'Value must be an integer between 1 to 5.' },
    ])
}




const promoCodeSettings = 'You can create a promotion code to apply to a complete cart, regardless of the club or branch products in the cart.'

function PromoCode(props) {
    const [clubs, setClubs] = useState([])
    const [branches, setBranches] = useState([])
    const [products, setProducts] = useState([])
    const [showClubSelect, setShowClubSelect] = useState(false)
    const [selectAllProducts, setSelectAllProducts] = useState(false)
    const promoCodeType = [
        { code: Constants.promoTypeNone, name: 'Select One', scope: 'AL' },
        { code: Constants.promoTypePercentage, name: '%Pct Off', scope: 'AL' },
        { code: Constants.promoTypeFixedAmount, name: '$Amt Off', scope: 'AL' },
        { code: Constants.promoTypeOther, name: 'Other', scope: 'PR' },
        { code: Constants.promoTypeWaived, name: 'Waived', scope: 'EN' },
        { code: Constants.promoTypeFreeAssociates, name: 'Free Associates', scope: 'AS' }]



    useEffect(() => doSelectFisrtClub(), [])

    useEffect(() => validateSelectedProduct(props.promoCodeProducts.map(x => Number(x.productId)), false), [props.sourceProducts])

    const doSelectFisrtClub = _ => {
        let showClubSelect = false
        const clubs = [...props.clubs]
        if (props.clubs.length > 1) {
            clubs.unshift({ clubId: '-1', name: '' })
            showClubSelect = true
        }
        setClubs(clubs)
        setShowClubSelect(showClubSelect)
        doFilterBranchesByClub(props.clubId)

    }

    const doFilterBranchesByClub = (clubId, clubHasChanged = false) => {
        let branchId = '-1'
        let branchName = ''
        const branches = props.branches.filter(x => x.clubId === +clubId)
        if (branches.length === 1) {
            branchId = branches[0].branchId
            branchName = branches[0].name
        }
        branches.unshift({ branchId: '-1', name: '', clubId: '-1' })
        setBranches(branches)
        if (clubHasChanged) {
            props.setSelectValue("branchId", branchId, "branchName", branchName)
            doFilterProductsByBranch(branchId, true)
        } else {
            doFilterProductsByBranch(props.branchId)
        }
    }

    const doFilterProductsByBranch = (branchId, branchHasChanged = false) => {
        setProducts([])
        setSelectAllProducts(false)
        if (+branchId <= 0) {
            props.setPromoCodeProducts([])
            return
        }
        let selectedProducts = props.promoCodeProducts.map(x => x.productId)
        if (branchHasChanged) {
            props.setPromoCodeProducts([])
            selectedProducts = []
        }

        doSelectAllProducts(branchId, props.startDate, props.endDate, props.promoCodeId, selectedProducts)

    }

    const doFilterProductsByDates = (value, startDateHasChanged = false, endDateHasChanged = false) => {

        setProducts([])
        setSelectAllProducts(false)
        if (props.branchId <= 0) {
            props.setPromoCodeProducts([])
            return
        }

        let selectedProducts = props.promoCodeProducts.map(x => x.productId)


        if (startDateHasChanged)
            doSelectAllProducts(props.branchId, value, props.endDate, props.promoCodeId, selectedProducts)
        else if (endDateHasChanged)
            doSelectAllProducts(props.branchId, props.startDate, value, props.promoCodeId, selectedProducts)

    }
    const doSelectAllProducts = (branchId, startDate, endDate, promoCodeId, selectedProducts) => {
        if (branchId !== -1 && startDate > '' && endDate > '') {
            getProducts(branchId, startDate.substring(0, 10), endDate.substring(0, 10), promoCodeId)
                .then(r => {
                    if (r.data.success) {
                        const prods = r.data.data
                        setSelectAllProducts((selectedProducts.length === prods.length))
                        setProducts(prods)
                        props.setSourceProducts(prods)
                        if (selectedProducts.length > 0)
                            validateSelectedProduct(selectedProducts)
                    }
                    else {
                        props.setPromoCodeProducts([])
                        props.handleError(r.data.errors.map(e => e.message), false)
                    }
                }).catch(e => {
                    console.log(e)
                })
        }
    }


    const renderBranchNames = _ => {
        return branches.map((branch) => {
            return <option value={branch.branchId} key={branch.branchId}>{branch.name}</option>
        });
    }

    const renderClubNames = _ => {
        return clubs.map((club) => {
            return <option value={club.clubId} key={club.clubId}>{club.name}</option>
        })
    }

    const renderPromoCodeTypes = (type) => {
        return promoCodeType.filter(x => x.scope === 'AL' || x.scope === type).map(r => {
            return <option value={r.code} key={r.code}>{r.name}</option>
        })
    }

    const renderProducts = _ => {
        return products.map(r => {
            return <option className='text-truncate py-1' value={r.productId} key={r.productId}>{r.name}</option>
        })
    }

    const validateSelectedProduct = (value) => {
        let errors = []
        let productsSelected = value.map(Number)
        if (props.sourceProducts) {
            let disableAssocPromo = props.sourceProducts.filter(product => productsSelected.includes(product.productId) && (product.freeAssociatesAllowedNumber > 0)).length > 0
            props.setFieldValue("disableAssocPromo", disableAssocPromo)
            if (disableAssocPromo) {
                resetAssociateSelection()
            }
            let disableAssocPromoByPrice = props.sourceProducts.filter(product => productsSelected.includes(product.productId) && (!product.costPerAssociate || product.costPerAssociate == 0)).length > 0
            props.setFieldValue("disableAssocPromoByPrice", disableAssocPromoByPrice)
            if (disableAssocPromoByPrice) {
                resetAssociateSelection()
            }
            let disableEnrollFeePromo = props.sourceProducts.filter(product => productsSelected.includes(product.productId) && product.enrollmentFee === 0).length > 0
            props.setFieldValue("disableEnrollFeePromo", disableEnrollFeePromo)
            if (disableEnrollFeePromo) {
                resetEnrollFeeSelection()
            }
        }
    }

    const resetEnrollFeeSelection = _ => {
        props.setFieldValue("applyToEnrollFee", false)
        props.setFieldValue("enrollFeePromoTypeCode", Constants.promoTypeNone)
        props.setFieldValue("enrollFeeFixedAmount", "")
        props.setFieldValue("enrollFeePercentage", "")
    }

    const resetAssociateSelection = _ => {
        props.setFieldValue("applyToAssoc", false)
        props.setFieldValue("assocPromoTypeCode", Constants.promoTypeNone)
        props.setFieldValue("assocFixedAmount", "")
        props.setFieldValue("assocPercentage", "")
        props.setFieldValue("assocFreeCount", "")
    }



    return <div className="row">
        <div className="col-md-6">
            <Col>
                <Row form>
                    <Col style={{ flex: 10 }} className={`${props.validation.promoCodeCode.isInvalid ? 'has-error' : ''}`}>
                        <Label htmlFor='promoCode' className="required-hint mt-4"><strong>Promo code</strong></Label>
                        <Input
                            type="text"
                            className={props.readOnly ? '' : 'input-editable'}
                            style={{ textTransform: 'uppercase' }}
                            readOnly={props.readOnly}
                            maxLength="20"
                            name="promoCodeCode"
                            id='promoCode'
                            value={props.promoCodeCode}
                            onChange={e => {
                                const val = e.target.value.replace(/[^a-z0-9]/gi, '', '')
                                props.setFieldValue(e.target.name, val)
                            }} />
                        {!props.readOnly && <InputFeedback feedbackText={feedback.promoCode} id='promoCode' />}
                        <span className="help-block">{props.validation.promoCodeCode.message}</span>
                    </Col>
                    <Col style={{ flex: 3 }}>
                        <div className="custom-control custom-checkbox mt-5 mr-sm-2">
                            <input
                                type="checkbox"
                                className='custom-control-input'
                                name="isSingleUse"
                                id="isSingleUse"
                                disabled={props.readOnly}
                                checked={props.isSingleUse}
                                onChange={e => props.setFieldValue(e.target.name, e.target.checked)} />
                            <label className="custom-control-label" htmlFor="isSingleUse">
                                <strong>Single use promo code</strong>
                            </label>
                        </div>
                    </Col>
                </Row>
            </Col>
            <Col className={`${props.validation.name.isInvalid ? 'has-error' : ''}`}>
                <Label htmlFor='name' className="required-hint mt-4"><strong>Promo code display name</strong></Label>
                <Input
                    id="name"
                    type="text"
                    className={props.readOnly ? '' : 'input-editable'}
                    readOnly={props.readOnly}
                    name="name"
                    maxLength="150"
                    autoComplete="off"
                    value={props.name}
                    onChange={e => {
                        const val = e.target.value.replace(/[^a-z0-9\s$%]/gi, '');
                        props.setFieldValue(e.target.name, val)
                    }} />
                <span className="help-block">{props.validation.name.message}</span>
            </Col>
            {showClubSelect && <Col className={`${props.validation.clubName.isInvalid ? 'has-error' : ''}`}>
                <Label htmlFor='clubIdSelect' className="mt-4"><strong>Club</strong></Label>
                <label className="select">
                    <select
                        id="clubIdSelect"
                        name="clubName"
                        className={props.readOnly || props.applyToCart ?
                            'form-control' : 'input-editable form-control'}
                        disabled={props.readOnly || props.applyToCart}
                        value={props.clubId}
                        onChange={(e) => {
                            const text = e.target.options[e.target.selectedIndex].text
                            const value = e.target.value
                            props.setSelectValue("clubId", value, "clubName", text)
                            doFilterBranchesByClub(value, true)
                        }}
                    >
                        {renderClubNames()}
                    </select>
                </label>
                <span className="help-block">{props.validation.clubName.message}</span>
            </Col>}
            <Col className={`${props.validation.branchName.isInvalid ? 'has-error' : ''}`}>
                <Label htmlFor='branchIdSelect' className="required-hint mt-4"><strong>Branch</strong></Label>
                <label className="select">
                    <select
                        id="branchIdSelect"
                        name="branchName"
                        className={props.readOnly || props.applyToCart ?
                            'form-control' : 'input-editable form-control'}
                        disabled={props.readOnly || props.applyToCart}
                        value={props.branchId}
                        onChange={(e) => {
                            const text = e.target.options[e.target.selectedIndex].text
                            const value = e.target.value
                            props.setSelectValue("branchId", value, "branchName", text)
                            doFilterProductsByBranch(value, true)
                        }}
                    >
                        {renderBranchNames()}
                    </select>
                </label>
                <span className="help-block">{props.validation.branchName.message}</span>
            </Col>

            <Col>
                {!props.readOnly && <Row form>
                    {<Col className={`${props.validation.startDate.isInvalid ?
                        'has-error' : ''}`}>
                        <Label htmlFor='startDate' className="required-hint mt-4"><strong>Start date</strong></Label>
                        <CustomDatePicker
                            id="startDate"
                            readOnly={props.readOnly}
                            defValue={!props.startDate ? "" : formatInTimeZoneDate(props.startDate, props.branchIanaTimeZoneId).substring(0, 10)}
                            label="Start Date"
                            overlayClass="promo-code-datepicker-overlay"
                            onChange={val => {
                                props.setFieldValue("startDate", val)
                                doFilterProductsByDates(val, true)
                                if (props.promoCodeId && props.promoCodeId !== 0) {
                                    const newEndDate = new Date(val);
                                    newEndDate.setDate(newEndDate.getDate() + 1);

                                    const formattedEndDate = newEndDate.toISOString();

                                    props.setFieldValue("endDate", formattedEndDate);
                                }
                                console.log(props);
                            }}
                        />
                        <InputFeedback feedbackText={feedback.startDate} id='startDate' />
                        <span className="help-block-calendar">{props.validation.startDate.message}</span>
                    </Col>}
                    <Col className={`${props.validation.endDate.isInvalid ? 'has-error' : ''}`}>
                        <Label htmlFor='endDate' className="required-hint mt-4"><strong>End date</strong></Label>
                        <CustomDatePicker
                            id="endDate"
                            readOnly={props.readOnly}
                            defValue={!props.endDate ? "" : formatInTimeZoneDate(props.endDate, props.branchIanaTimeZoneId).substring(0, 10)}
                            label="End Date"
                            overlayClass="promo-code-datepicker-overlay"
                            onChange={val => {
                                props.setFieldValue("endDate", val)
                                doFilterProductsByDates(val, false, true)
                            }}
                        />
                        <span className="help-block-calendar">{props.validation.endDate.message}</span>
                    </Col>
                </Row>}
                {props.readOnly && <Row form>
                    <Col>
                        <Label htmlFor='_startDate' className="required-hint mt-4"><strong>Start date</strong></Label>
                        <Input
                            id="_startDate"
                            readOnly={props.readOnly}
                            className=''
                            value={formatInTimeZoneDate(props.startDate, props.branchIanaTimeZoneId)}
                        />
                    </Col>
                    <Col>
                        <Label htmlFor='_endDate' className="required-hint mt-4"><strong>End date</strong></Label>
                        <Input
                            id="_endDate"
                            readOnly={props.readOnly}
                            className=''
                            value={formatInTimeZoneDate(props.endDate, props.branchIanaTimeZoneId)}
                        />
                    </Col>
                </Row>}
            </Col>
            <Col>
                <Row form>
                    <Col style={{ flex: 10 }} className={`${props.validation.promoCodeProducts.isInvalid ? 'has-error' : ''}`}>
                        <Label htmlFor='promoCodeProduct' className="required-hint mt-4"><strong>Product Level - Display Name</strong></Label>
                        <label className="select">
                            <select
                                name="promoCodeProducts"
                                id='promoCodeProduct'
                                className={props.readOnly || props.applyToCart ?
                                    'form-control' : 'input-editable form-control'}
                                disabled={props.readOnly || props.applyToCart || !props.branchId
                                    || !props.startDate || !props.endDate}
                                multiple={true}
                                size="7"
                                value={props.promoCodeProducts.map(r => r.productId)}
                                onChange={(e) => {
                                    const val = Array.from(e.target.selectedOptions, option => option.value)
                                    setSelectAllProducts(val.length === products.length)
                                    validateSelectedProduct(val)
                                    props.setPromoCodeProducts(val)
                                }}
                            >
                                {renderProducts()}
                            </select>
                            {!props.readOnly && <InputFeedback feedbackText={feedback.promoCodeProduct} id='promoCodeProduct' />}
                        </label>
                        <span className="help-block">{props.validation.promoCodeProducts.message}</span>
                    </Col>
                    <Col style={{ flex: 3 }}>
                        <div className="custom-control custom-checkbox mt-5 mr-sm-2">
                            <input
                                type="checkbox"
                                className='custom-control-input'
                                name="selectAllProducts"
                                id="selectAllProducts"
                                disabled={props.readOnly || props.applyToCart}
                                checked={selectAllProducts}
                                onChange={e => {
                                    const val = e.target.checked
                                    if (val)
                                        props.setPromoCodeProducts(products.map(x => x.productId))
                                    else
                                        props.setPromoCodeProducts([])
                                    setSelectAllProducts(p => !p)
                                    validateSelectedProduct(val ? products.map(x => x.productId) : [])
                                }} />
                            <label className="custom-control-label" htmlFor="selectAllProducts">
                                <strong>Apply to all products</strong>
                            </label>
                        </div>
                    </Col>
                </Row>
            </Col>
        </div >
        <div className="col-md-6">
            <Col>
                <Row className="mb-3" form>
                    <Col style={{ flex: 5 }}>
                        <Label htmlFor='applyToPrimeMember' className="mt-4"><strong>Discount Area</strong><span className="discount-span" >(Check at least one)</span></Label>
                        <div className="custom-control custom-checkbox mr-sm-2">
                            <input
                                type="checkbox"
                                className='custom-control-input'
                                name="applyToPrimeMember"
                                id="applyToPrimeMember"
                                disabled={props.readOnly}
                                checked={props.applyToPrimeMember}
                                onChange={e => {
                                    if (!e.target.checked)
                                        props.setFieldValue('promoTypeCode', Constants.promoTypeNone)
                                    props.setFieldValue(e.target.name, e.target.checked)
                                    props.updatePromoTypeSelected(e.target.name, e.target.checked)
                                }} />
                            <label className="custom-control-label" htmlFor="applyToPrimeMember">
                                <strong>Primary Membership</strong>
                            </label>
                        </div>
                    </Col>
                    <Col style={{ flex: 4 }}>
                        <Label htmlFor='promoTypeCode' className="required-hint mt-4"><strong>Discount type</strong></Label>
                        <label className="select">
                            <select
                                name="promoTypeCode"
                                id="promoTypeCode"
                                className={props.readOnly ?
                                    'form-control' : 'input-editable form-control'}
                                disabled={props.readOnly || !props.applyToPrimeMember}
                                value={props.promoTypeCode}
                                onChange={(e) => props.setPromoTypeCode(e.target.value)}
                            >
                                {renderPromoCodeTypes('PR')}
                            </select>
                        </label>
                        <span className="help-block">{props.validation.promoTypeCode.message}</span>
                    </Col>
                    <Col
                        style={{ flex: 4 }}
                        className={`${props.validation.percentage.isInvalid ||
                            props.validation.fixedAmount.isInvalid ||
                            props.validation.promoCodeNote.isInvalid
                            ? 'has-error'
                            : ''
                            }`}
                    >
                        <div className="required-hint inline-label div-label-margin mt-4">
                            <strong>
                                {props.promoTypeCode === "OT" ? "Promo code Note" : "Discount Amount"}
                            </strong>
                        </div>
                        <InputGroup id='discountPrimary'>
                            <InputGroupText className='currency-prefix' addonType="prepend">
                                {props.promoTypeCode === "FA" ? '$' : (props.promoTypeCode === "PE" ? '%' : '')}
                            </InputGroupText>
                            {props.promoTypeCode === Constants.promoTypeFixedAmount &&
                                <Input
                                    type="number"
                                    name="fixedAmount"
                                    id="fixedAmount"
                                    min="1"
                                    readOnly={props.readOnly}
                                    disabled={!props.applyToPrimeMember}
                                    className={props.readOnly ? '' : 'input-editable'}
                                    value={props.fixedAmount}
                                    onChange={e => props.setFieldValue(e.target.name, e.target.value)}
                                />
                            }
                            {props.promoTypeCode === Constants.promoTypePercentage &&
                                <Input
                                    type="number"
                                    name="percentage"
                                    id="percentage"
                                    min="1"
                                    readOnly={props.readOnly}
                                    disabled={!props.applyToPrimeMember}
                                    className={props.readOnly ? '' : 'input-editable'}
                                    value={props.percentage}
                                    onChange={e => props.setFieldValue(e.target.name, e.target.value)}
                                />
                            }
                            {props.promoTypeCode === Constants.promoTypeOther &&
                                <Input
                                    name="promoCodeNote"
                                    id="promoCodeNote"
                                    maxLength="25"
                                    readOnly={props.readOnly}
                                    disabled={!props.applyToPrimeMember}
                                    className={props.readOnly ? '' : 'input-editable'}
                                    value={props.promoCodeNote}
                                    onChange={e => {
                                        const value = e.target.value.slice(0, 25);
                                        props.setFieldValue(e.target.name, value)
                                    }}
                                />
                            }
                        </InputGroup>
                        {!props.readOnly && props.promoTypeCode === Constants.promoTypeFixedAmount && (
                            <InputFeedback feedbackText={feedback.fixedAmount} id='fixedAmount' />
                        )}
                        {!props.readOnly && props.promoTypeCode === Constants.promoTypePercentage && (
                            <InputFeedback feedbackText={feedback.percentage} id='percentage' />
                        )}
                        {!props.readOnly && props.promoTypeCode === Constants.promoTypeOther && (
                            <InputFeedback feedbackText={feedback.other} id='promoCodeNote' />
                        )}
                        {props.promoTypeCode === Constants.promoTypeFixedAmount && (
                            <span className="help-block">
                                {props.validation.fixedAmount.message}
                            </span>
                        )}
                        {props.promoTypeCode === Constants.promoTypePercentage && (
                            <span className="help-block">
                                {props.validation.percentage.message}
                            </span>
                        )}
                        {props.promoTypeCode === Constants.promoTypeOther && (
                            <span className="help-block">
                                {props.validation.promoCodeNote.message}
                            </span>
                        )}
                    </Col>
                </Row>
                <Row className="mb-3" form>
                    <Col style={{ flex: 5 }}>
                        <div className="custom-control custom-checkbox mr-sm-2">
                            <input
                                type="checkbox"
                                className='custom-control-input'
                                name="applyToEnrollFee"
                                id="applyToEnrollFee"
                                disabled={props.readOnly || props.disableEnrollFeePromo}
                                checked={props.applyToEnrollFee}
                                onChange={e => {
                                    if (!e.target.checked)
                                        props.setFieldValue('enrollFeePromoTypeCode', Constants.promoTypeNone)
                                    props.setFieldValue(e.target.name, e.target.checked)
                                    props.updatePromoTypeSelected(e.target.name, e.target.checked)
                                }} />
                            <label className="custom-control-label" htmlFor="applyToEnrollFee">
                                <strong>Enrollment Fee</strong>
                            </label>
                        </div>
                    </Col>
                    <Col style={{ flex: 4 }}>
                        <label className="select">
                            <select
                                name="enrollFeePromoTypeCode"
                                id="enrollFeePromoTypeCode"
                                className={props.readOnly ?
                                    'form-control' : 'input-editable form-control'}
                                disabled={props.readOnly || !props.applyToEnrollFee}
                                value={props.enrollFeePromoTypeCode}
                                onChange={(e) => {
                                    props.setEnrollFeePromoTypeCode(e.target.value)
                                }}
                            >
                                {renderPromoCodeTypes('EN')}
                            </select>
                        </label>
                        <span className="help-block">{props.validation.enrollFeePromoTypeCode.message}</span>
                    </Col>
                    <Col style={{ flex: 4 }} className={`${props.validation.enrollFeePercentage.isInvalid
                        || props.validation.enrollFeeFixedAmount.isInvalid ? 'has-error' : ''}`}>
                        <InputGroup id='discountEnrollment'>
                            <InputGroupText className='currency-prefix' addonType="prepend">
                                {props.enrollFeePromoTypeCode === "FA" ? '$' : '%'}</InputGroupText>
                            {props.enrollFeePromoTypeCode === Constants.promoTypeFixedAmount && <Input
                                type="number"
                                name="enrollFeeFixedAmount"
                                id="enrollFeeFixedAmount"
                                min="1"
                                readOnly={props.readOnly}
                                disabled={!props.applyToEnrollFee}
                                className={props.readOnly ? '' : 'input-editable'}
                                value={props.enrollFeeFixedAmount}
                                onChange={e => props.setFieldValue(e.target.name, e.target.value)} />}
                            {(props.enrollFeePromoTypeCode === Constants.promoTypePercentage)
                                && < Input
                                    type="number"
                                    name="enrollFeePercentage"
                                    id="enrollFeePercentage"
                                    min="1"
                                    readOnly={props.readOnly}
                                    disabled={!props.applyToEnrollFee}
                                    className={props.readOnly ? '' : 'input-editable'}
                                    value={props.enrollFeePercentage}
                                    onChange={e => props.setFieldValue(e.target.name, e.target.value)}
                                />}
                            {(props.enrollFeePromoTypeCode === Constants.promoTypeWaived)
                                && < Input
                                    type="number"
                                    name="enrollFeeWaived"
                                    id="enrollFeeWaived"
                                    min="1"
                                    readOnly={props.readOnly}
                                    disabled={!props.applyToEnrollFee || props.enrollFeePromoTypeCode === Constants.promoTypeWaived}
                                    className={props.readOnly ? '' : 'input-editable'}
                                    value={props.enrollFeeWaived}
                                    onChange={e => props.setFieldValue(e.target.name, e.target.value)}
                                />}
                        </InputGroup>
                        {!props.readOnly && props.enrollFeePromoTypeCode === Constants.promoTypeFixedAmount && <InputFeedback feedbackText={feedback.fixedAmount} id='enrollFeeFixedAmount' />}
                        {!props.readOnly && props.enrollFeePromoTypeCode === Constants.promoTypePercentage && <InputFeedback feedbackText={feedback.percentage} id='enrollFeePercentage' />}
                        {!props.readOnly && props.enrollFeePromoTypeCode === Constants.promoTypeWaived && <InputFeedback feedbackText={feedback.percentage} id='enrollFeeWaived' />}
                        {props.enrollFeePromoTypeCode === Constants.promoTypeFixedAmount && <span className="help-block">{props.validation.enrollFeeFixedAmount.message}</span>}
                        {props.enrollFeePromoTypeCode === Constants.promoTypePercentage && <span className="help-block">{props.validation.enrollFeePercentage.message}</span>}
                        {props.enrollFeePromoTypeCode === Constants.promoTypeWaived && <span className="help-block">{props.validation.enrollFeePercentage.message}</span>}
                    </Col>
                </Row>
                <Row className="mb-3" form>
                    <Col style={{ flex: 5 }}>
                        <div className="custom-control custom-checkbox mr-sm-2">
                            <input
                                type="checkbox"
                                className='custom-control-input'
                                name="applyToAssoc"
                                id="applyToAssoc"
                                disabled={props.readOnly || props.disableAssocPromo || props.disableAssocPromoByPrice}
                                checked={props.applyToAssoc}
                                onChange={e => {
                                    if (!e.target.checked)
                                        props.setFieldValue('assocPromoTypeCode', Constants.promoTypeNone)
                                    props.setFieldValue(e.target.name, e.target.checked)
                                    props.updatePromoTypeSelected(e.target.name, e.target.checked)
                                }} />
                            <label className="custom-control-label" htmlFor="applyToAssoc">
                                <strong>Associates</strong>
                            </label>
                        </div>
                    </Col>
                    <Col style={{ flex: 4 }}>
                        <label className="select">
                            <select
                                name="assocPromoTypeCode"
                                id="assocPromoTypeCode"
                                className={props.readOnly ?
                                    'form-control' : 'input-editable form-control'}
                                disabled={props.readOnly || !props.applyToAssoc}
                                value={props.assocPromoTypeCode}
                                onChange={(e) => props.setAssocPromoTypeCode(e.target.value)}
                            >
                                {renderPromoCodeTypes('AS')}
                            </select>
                        </label>
                        <span className="help-block">{props.validation.assocPromoTypeCode.message}</span>
                    </Col>
                    <Col style={{ flex: 4 }} className={`${props.validation.assocPercentage.isInvalid
                        || props.validation.assocFixedAmount.isInvalid || props.validation.assocFreeCount.isInvalid ? 'has-error' : ''}`}>
                        <InputGroup id='discountAssociate'>
                            <InputGroupText className='currency-prefix' addonType="prepend">
                                {props.assocPromoTypeCode === "FA" ? '$' : (props.assocPromoTypeCode === "PE" ? '%' : '')}</InputGroupText>
                            {props.assocPromoTypeCode === Constants.promoTypeFixedAmount && <Input
                                type="number"
                                name="assocFixedAmount"
                                id="assocFixedAmount"
                                min="1"
                                readOnly={props.readOnly}
                                disabled={!props.applyToAssoc}
                                className={props.readOnly ? '' : 'input-editable'}
                                value={props.assocFixedAmount}
                                onChange={e => props.setFieldValue(e.target.name, e.target.value)} />}
                            {props.assocPromoTypeCode === Constants.promoTypePercentage && <Input
                                type="number"
                                name="assocPercentage"
                                id="assocPercentage"
                                min="1"
                                readOnly={props.readOnly}
                                disabled={!props.applyToAssoc}
                                className={props.readOnly ? '' : 'input-editable'}
                                value={props.assocPercentage}
                                onChange={e => props.setFieldValue(e.target.name, e.target.value)} />}
                            {props.assocPromoTypeCode === Constants.promoTypeFreeAssociates &&
                                <select
                                    name="assocFreeCount"
                                    id="assocFreeCount"
                                    readOnly={props.readOnly}
                                    disabled={!props.applyToAssoc}
                                    className={props.readOnly ? 'form-control' : 'input-editable form-control'}
                                    style={{ appearance: 'menulist' }}
                                    value={props.assocFreeCount}
                                    onChange={e => props.setFieldValue(e.target.name, e.target.value)}>
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                </select>}
                        </InputGroup>
                        {!props.readOnly && props.assocPromoTypeCode === Constants.promoTypeFixedAmount && <InputFeedback feedbackText={feedback.fixedAmount} id='assocFixedAmount' />}
                        {!props.readOnly && props.assocPromoTypeCode === Constants.promoTypePercentage && <InputFeedback feedbackText={feedback.percentage} id='assocPercentage' />}
                        {!props.readOnly && props.assocPromoTypeCode === Constants.promoTypeFreeAssociates && <InputFeedback feedbackText={feedback.freeAssociates} id='assocFreeCount' />}
                        {props.assocPromoTypeCode === Constants.promoTypeFixedAmount && <span className="help-block">{props.validation.assocFixedAmount.message}</span>}
                        {props.assocPromoTypeCode === Constants.promoTypePercentage && <span className="help-block">{props.validation.assocPercentage.message}</span>}
                        {props.assocPromoTypeCode === Constants.promoTypeFreeAssociates && <span className="help-block">{props.validation.assocFreeCount.message}</span>}
                    </Col>
                </Row>
            </Col>
            {props.readOnly && <Col>
                <Label htmlFor='promoCodeStatus' className="mt-4"><strong>Status</strong></Label>
                <Input
                    id="promoCodeStatus"
                    name="promoCodeStatus"
                    readOnly={true}
                    value={props.promoCodeStatus}>
                </Input>
            </Col>}
            <Col className="float-bottom justify-content-end" style={(!props.promoCodeStatus) ? { paddingTop: "45%" } : { paddingTop: "30%" }}>
                {props.disableEnrollFeePromo && <span className="help-block">{feedback.disableEnrollFeePromo}</span>}
            </Col>
            <Col className="float-bottom justify-content-end" style={{ paddingTop: "5%" }}>
                {props.disableAssocPromo && <span className="help-block">{feedback.disableAssocPromoCodeByCount}</span>}
            </Col>
            <Col className="float-bottom justify-content-end" style={{ paddingTop: "5%" }}>
                {props.disableAssocPromoByPrice && <span className="help-block">{feedback.disableAssocPromoCodeByPrice}</span>}
            </Col>
            <Col className="div-bottom text-right float-bottom d-flex flex-wrap justify-content-end flex-row">
                <Button onClick={props.handleCancel} className="cancel-btn">CANCEL</Button>
                <Button onClick={props.handleEdit} className={props.readOnly ? 'mail-btn ml-4' : 'd-none'}>EDIT</Button>
                <Button onClick={props.handleSubmit} type="submit" color="primary" className={props.readOnly ? 'd-none' : 'mail-btn ml-4'}>SAVE</Button>
            </Col>
        </div>
    </div >
}

export default PromoCode